import React from 'react';
import ModuleBudgetEntry from '../shared/ModuleBudgetEntry';

// =============================================================================
// Manufacturing › Fixed Costs
// The OPEX capture grid, showing only GL lines whose source_module is
// MOD_3_MAKE (set on Budget Setup > GL Lines). Same grid, same behaviour —
// see shared/ModuleBudgetEntry.jsx.
//
// Replaces the earlier dummy-data mockup.
// =============================================================================

const MfgFixedCosts = () => (
  <ModuleBudgetEntry
    title="Manufacturing Fixed Costs"
    description="Baseline fixed factory costs. Capture and adjust; changes save automatically."
    module="MOD_3_MAKE"
  />
);

export default MfgFixedCosts;
